import React from 'react';
import clsx from '@strava/ui/clsx';
import Avatar, { AvatarType } from '@strava/ui/Avatar';
import { useStravaTranslations } from '@strava/container-context';
import {
  getTitleAndSubtitle,
  RegMessageVariants
} from '../../helpers/getTitleAndSubtitle';
import styles from './DesktopRegistrationMessage.module.scss';

export type DesktopRegistrationMessageProps = {
  variant: RegMessageVariants;
  name?: string;
  avatar?: string;
  avatarType?: AvatarType;
};

export const DesktopRegistrationMessage = ({
  variant,
  name,
  avatar,
  avatarType
}: DesktopRegistrationMessageProps) => {
  const { t } = useStravaTranslations();
  const { title, subtitle } = getTitleAndSubtitle(t, variant, name);

  return (
    <>
      <div
        className={clsx(
          styles.registrationMessage,
          avatar && styles.withAvatar
        )}
      >
        {avatar && (
          <Avatar
            title={name || ''}
            type={avatarType || 'athlete'}
            size="large"
            src={avatar}
          />
        )}
        <h1 className={styles.heading} data-cy="reg-message-title">
          {title}
        </h1>
      </div>
      {subtitle && (
        <div className={styles.subheadingContainer}>
          <h2 className={styles.subheading} data-cy="reg-message-subtitle">
            {subtitle}
          </h2>
        </div>
      )}
    </>
  );
};

export default DesktopRegistrationMessage;
